var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDietAdvice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 230,
    height: 229,
    viewBox: "0 0 230 229",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M148.287 174.43C143.326 174.43 139.305 170.409 139.305 165.448V156.466C139.305 151.505 143.326 147.484 148.287 147.484C153.247 147.484 157.269 151.505 157.269 156.466C157.269 156.712 157.269 166.044 157.269 165.448C157.269 170.409 153.247 174.43 148.287 174.43Z",
    stroke: "#7f56d9",
    strokeWidth: 7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M183.876 174.43H183.803C178.862 174.43 174.858 170.425 174.858 165.485V156.43C174.858 151.489 178.862 147.484 183.803 147.484H183.876C188.816 147.484 192.821 151.489 192.821 156.43V165.485C192.821 170.425 188.816 174.43 183.876 174.43Z",
    stroke: "#7f56d9",
    strokeWidth: 7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M174.858 160.953H157.269",
    stroke: "#7f56d9",
    strokeWidth: 7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M103.323 4.47266C103.323 10.0478 103.323 196.502 103.323 202.073",
    stroke: "#7f56d9",
    strokeWidth: 7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M202.123 103.273H103.323",
    stroke: "#7f56d9",
    strokeWidth: 7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M202.124 103.273C202.124 48.7081 157.888 4.47266 103.324 4.47266C48.7589 4.47266 4.52344 48.7081 4.52344 103.273C4.52344 157.837 48.7589 202.072 103.324 202.072",
    stroke: "#7f56d9",
    strokeWidth: 7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M121.287 224.529C178.333 224.529 224.578 178.284 224.578 121.238H121.287V224.529Z",
    stroke: "#7f56d9",
    strokeWidth: 7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5334 62.8555C65.0784 62.8555 62.779 63.6252 60.7971 64.9634C58.8149 63.6252 56.5155 62.8555 54.0609 62.8555C46.6202 62.8555 40.5879 69.8923 40.5879 78.5737C40.5879 87.2543 46.6197 98.783 54.0609 98.783C56.5159 98.783 58.8149 98.0132 60.7971 96.675C62.779 98.0132 65.0784 98.783 67.5334 98.783C74.9741 98.783 81.0059 87.2547 81.0059 78.5737C81.0059 69.8927 74.9741 62.8555 67.5334 62.8555Z",
    stroke: "#7f56d9",
    strokeWidth: 7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0415 44.9297C56.9337 49.2315 55.3275 56.1346 60.7962 64.9641",
    stroke: "#7f56d9",
    strokeWidth: 7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4692 121.238H80.8693",
    stroke: "#7f56d9",
    strokeWidth: 7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M40.752 143.688H80.869",
    stroke: "#7f56d9",
    strokeWidth: 7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9058 166.145H80.8693",
    stroke: "#7f56d9",
    strokeWidth: 7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M130.269 65.1013C130.269 57.6606 143.742 38.1562 143.742 38.1562C143.742 38.1562 157.215 57.6606 157.215 65.1013C157.215 72.5425 151.183 78.5743 143.742 78.5743C136.301 78.5743 130.269 72.5425 130.269 65.1013Z",
    stroke: "#7f56d9",
    strokeWidth: 7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDietAdvice);
export default __webpack_public_path__ + "static/media/dietAdvice.d5bdd842adf4b16ee2045d066d83ccf9.svg";
export { ForwardRef as ReactComponent };